var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (true)?_c('div',{staticClass:"summernoteBox"},[_c('div',{attrs:{"id":_vm.id}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }